import { render, staticRenderFns } from "./LogoutDialog.vue?vue&type=template&id=3383f966&"
import script from "./LogoutDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LogoutDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3383f966')) {
      api.createRecord('3383f966', component.options)
    } else {
      api.reload('3383f966', component.options)
    }
    module.hot.accept("./LogoutDialog.vue?vue&type=template&id=3383f966&", function () {
      api.rerender('3383f966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/LogoutDialog.vue"
export default component.exports